export default {
  red: 'red',
  amber: 'amber',
  green: 'green',
};
